import React from 'react';

import PipelinePageContextProvider from './PipelinePageContextProvider';
import PipelineDetailsContent from './PipelineDetailsContent';

export default function PipelineDetailsPage() {
  return (
    <PipelinePageContextProvider>
      <PipelineDetailsContent />
    </PipelinePageContextProvider>
  );
}
